import { z } from 'zod';
import { AgentAskOutcome, AgentCitation, AgentProviderCitation } from './schemas/agent.js';
/**
 * Vaste synthetische Entra-oid van de demo-gebruiker (spec #37, issue #39).
 * Moet een geldige UUID zijn omdat User- en Session-schema daarop valideren.
 * Eén bron voor drie afnemers: de demo-login (backend/src/routes/auth.demo.ts),
 * het seed-script (backend/scripts/seed-demo.ts) en de tests.
 */
export const DEMO_ENTRA_OID = '00000000-0000-4000-8000-0000000000d0';
/**
 * Gescripte Mila-vraag in de demo-omgeving (spec #37 wijziging C, issue #41).
 * Documenten leven in de collectie `demo_qa` van de named database `demo` —
 * nooit in productie. Citaties hergebruiken het agent-contract zodat de
 * bestaande antwoord-UI (bronkaartjes, crisisweergave) ongewijzigd rendert.
 */
/**
 * Gescripte vervolgvraag (doorvragen) bij een demo-vraag: zelfde antwoordvorm
 * als de hoofdvraag, maar zonder eigen plek in het vraagraster — de knoppen
 * verschijnen pas nadat de bijbehorende hoofdvraag is gesteld, zodat de demo
 * het multiturn-gedrag van de echte Mila naspeelt.
 */
export const DemoQaFollowUpSchema = z.object({
    id: z.string().min(1).max(100),
    question: z.string().min(1).max(1000),
    answer: z.string().min(1).max(20000),
    citations: z.array(AgentCitation).max(10).default([]),
    providerCitations: z.array(AgentProviderCitation).max(8).default([]),
    outcome: AgentAskOutcome.default('success'),
});
export const DemoQaItemSchema = z.object({
    id: z.string().min(1).max(100),
    /** Volgorde van de vraagknoppen (1-10). */
    order: z.number().int().min(1).max(100),
    question: z.string().min(1).max(1000),
    answer: z.string().min(1).max(20000),
    citations: z.array(AgentCitation).max(10).default([]),
    providerCitations: z.array(AgentProviderCitation).max(8).default([]),
    outcome: AgentAskOutcome.default('success'),
    followUps: z.array(DemoQaFollowUpSchema).max(5).default([]),
});
/**
 * Gescripte doorvragen bij een geseed historisch gesprek (rail): wie zo'n
 * gesprek opent, krijgt vervolgvragen die inhoudelijk op dát gesprek
 * aansluiten. Opgeslagen in dezelfde `demo_qa`-collectie als docs zonder
 * `order` maar mét `chatId`; de route splitst op vorm.
 */
export const DemoChatFollowUps = z.object({
    chatId: z.string().min(1).max(100),
    followUps: z.array(DemoQaFollowUpSchema).min(1).max(5),
});
export const DemoQaResponse = z.object({
    items: z.array(DemoQaItemSchema),
    chatFollowUps: z.array(DemoChatFollowUps).default([]),
});
//# sourceMappingURL=demo.js.map